import { IPath } from "@/domain/entities/lineInfo";
import { useServiceStore } from "@/stores/serviceStore";
import { NaveMapPolyLineStyle, NaverMapPolyLineStyleType } from "@/types";
import { ref } from "vue";

interface NaverMapPathOptions {
  paths: IPath[];
  strokeColor?: string;
  strokeWeight?: number;
  strokeStyle?: NaverMapPolyLineStyleType;
}

/** naver지도에 그려질 경로를 관리하는 컴포저블 */
export const useNaverMapPaths = () => {
  const serviceStore = useServiceStore();
  const shouldShowTurnPath = serviceStore.serviceInfo?.shouldShowTurnPath;

  const naverMapPaths = ref<any[]>([]);
  let polyLines: any[] = [];

  const drawNaverMapPaths = (
    naverMap: any,
    {
      paths,
      strokeColor = "#8dcd33b3",
      strokeWeight = 4,
      strokeStyle = NaveMapPolyLineStyle.SOLID,
    }: NaverMapPathOptions
  ) => {
    if (!naverMap || !shouldShowTurnPath || !paths.length) return;

    naverMapPaths.value = paths.map(
      (path) => new window.naver.maps.LatLng(path.latitude, path.longitude)
    );

    const polyLine = new window.naver.maps.Polyline({
      map: naverMap,
      path: naverMapPaths.value,
      strokeColor,
      strokeWeight,
      strokeStyle,
      strokeLineCap: "round",
    });
    polyLines.push(polyLine);
  };

  const resetNaverMapPaths = () => {
    polyLines?.forEach((polyLine) => {
      polyLine?.setMap(null);
    });
    polyLines = [];
    naverMapPaths.value = [];
  };

  return {
    naverMapPaths,
    drawNaverMapPaths,
    resetNaverMapPaths,
  };
};
